import React from 'react';
import PropTypes from 'prop-types';
import GraphicsList from './GraphicsList';

const GraphicsSectionDesktop = ({ phoneBg, dir, title, items }) => {
  return (
    <section style={{ maxWidth: 1200, margin: '0 auto', background: '#fff', padding: '80px 84px 60px', boxSizing: 'border-box' }} aria-label="graphics-desktop">
      <div style={{ margin: '0 0 80px' }}>
        <h2 style={{ margin: 0, fontSize: 28, fontWeight: 600, color: '#222', textAlign: dir === 'rtl' ? 'right' : 'left' }} dir={dir}>
          {title}
        </h2>
      </div>

      <div style={{
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: '55% 1fr',
        columnGap: 48,
        alignItems: 'center',
        direction: 'ltr'
      }}>
        <div style={{ width: '100%' }}>
          <img src={phoneBg} alt="" aria-hidden="true" style={{ width: '100%', height: 'auto', display: 'block' }} />
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <GraphicsList items={items} dir={dir} />
        </div>
      </div>
    </section>
  );
};

GraphicsSectionDesktop.propTypes = {
  phoneBg: PropTypes.string.isRequired,
  dir: PropTypes.string,
  title: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ).isRequired
};

export default GraphicsSectionDesktop;
